/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageHeaderController = /** @class */ (function () {
            function ApPageHeaderController($location, $scope, $window, applicationService, authenticationService, locationService, appSettings) {
                var _this = this;
                this.$location = $location;
                this.$scope = $scope;
                this.$window = $window;
                this.applicationService = applicationService;
                this.authenticationService = authenticationService;
                this.locationService = locationService;
                this.appSettings = appSettings;
                this.keys = ap.Constants.translationKeys.shell;
                this.firstName = this.authenticationService.authorizationData.FirstName;
                this.isRedCap = false;
                this.$scope.$on(ap.Constants.eventNames.angular.routeChangeSuccess, function () { return _this.init(); });
                this.logoUrl = this.appSettings.urls.dynamicContentUrl + '/1234/x/images/solera-autopoint_logo2019.svg';
                this.init();
            }
            ApPageHeaderController.prototype.init = function () {
                this.organizationCacheKey = this.locationService.getOrganizationCacheKey();
                this.isRedCap = this.$location.search().thirdparty === ThirdParty.RedCap;
                if (this.isRedCap) {
                    angular.element('body').css('background-color', "#fff");
                }
            };
            ApPageHeaderController.prototype.logout = function () {
                this.authenticationService.logout();
            };
            ApPageHeaderController.$inject = [
                '$location',
                '$scope',
                '$window',
                'applicationService',
                'authenticationService',
                'locationService',
                'appSettings'
            ];
            return ApPageHeaderController;
        }());
        Directives.ApPageHeaderController = ApPageHeaderController;
        angular
            .module('app.Directives')
            .controller('ApPageHeaderController', ApPageHeaderController);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
